<script>
import {computed} from "vue";

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Contact",
  props: {
    showModal: {
      type:Boolean,
      default: false
    }
  },
  // data() {
  //   return {
  //
  //     visible: false
  //   }
  // },
  methods: {
    close() {
      this.$emit('update:visible', false);
    }
  },
  setup(props, {emit}) {
    const visible = computed({
      get: () => props.showModal,
      set: (val) => {
        emit('update:showModal', val)
      }
    })
    return {
      visible
    }
  }
}
</script>

<template>
  <div class="modal"  v-show="false"  tabindex="-1">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Modal title</h5>
          <button type="button" class="close" data-dismiss="modal" @click="close" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <p>Modal body text goes here.</p>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
          <button type="button" class="btn btn-primary">Save changes</button>
        </div>
      </div>
    </div>
  </div>

</template>

<style scoped lang="scss">
.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}
.modal-content {
  background-color: white;
  padding: 20px;
  border-radius: 5px;
}

</style>